<template>
    <footer class="footer">
        <div class="footer-top">
            <div class="container">
                <div class="row">
                    <div class="col-sm-12 col-md-3 footer-lg">
                        <a href="#">
                            <FooterLogo></FooterLogo>
                        </a>
                    </div>
                    <div class="col-sm-12 col-md-5 footer-menu">
                        <ul>
                            <li>
                                <a href="#">Главная</a>
                            </li>
                            <li>
                                <a href="#">Преимущества</a>
                            </li>
                            <li>
                                <a href="#">Возможности</a>
                            </li>
                            <li>
                                <a href="#">Галерея</a>
                            </li>
                        </ul>
                        <ul>
                            <li>
                                <a href="#">Подписаться</a>
                            </li>
                            <li>
                                <a href="#">Поддержать</a>
                            </li>
                            <li>
                                <a href="#">Котакты</a>
                            </li>
                        </ul>
                    </div>
                    <div class="col-sm-12 col-md-4 footer-social">
                        <div class="footer-social-title">
                            Мы в соцсетях
                        </div>
                        <!-- Social Buttons -->
                        <section class="social-icons">
                            <h3 class="hide">Social Buttons</h3>
                            <a class="btn-social facebook" data-toggle="tooltip" data-placement="top" title="Facebook" href="#" target="_blank"><span class="fa fa-facebook"></span></a>
                            <a class="btn-social twitter" data-toggle="tooltip" data-placement="top" title="Twitter" href="#" target="_blank"><span class="fa fa-twitter"></span></a>
                            <a class="btn-social google-plus" data-toggle="tooltip" data-placement="top" title="Google+" href="#" target="_blank"><span class="fa fa-google-plus"></span></a>
                            <a class="btn-social youtube" data-toggle="tooltip" data-placement="top" title="Youtube" href="#" target="_blank"><span class="fa fa-youtube"></span></a>
                            <a class="btn-social instagram" data-toggle="tooltip" data-placement="top" title="Instagram" href="#" target="_blank"><span class="fa fa-instagram"></span></a>
                            <a class="btn-social email" data-toggle="tooltip" data-placement="top" title="Email" href="#" target="_blank"><span class="fa fa-envelope"></span></a>
                            <a class="btn-social rss" data-toggle="tooltip" data-placement="top" title="RSS" href="#" target="_blank"><span class="fa fa-rss"></span></a>
                        </section>
                        <!-- End Social Buttons -->
                    </div>
                </div>
            </div>
        </div>
        <div class="footer-bottom">
            <div class="container">
                <div class="row">
                    <span class="col-xs-12 footer-copyright">© 2018 — Hottt. All rights reserved.</span>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
    import FooterLogo from '@/assets/svg/tt_logo5_text.svg';

    export default {
        name: "Footer",
        components: {
            FooterLogo
        }

    }
</script>


// WEBPACK FOOTER //
// Footer.vue?6272740c